import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  fqv: {
    height: 20,
    width: 100,
  },
  earnedOn: {
    height: 20,
    width: 140,
  },
  entities: {
    height: 20,
    width: 100,
  },
});
